// default styles used for inheritance in global styles
const defaultTextError = {
  fontFamily: 'satoshi-medium',
  fontSize: 12,
  lineHeight: 16,
  color: '#DA2A52',
  margin: 0,
};

// .......styling for rendering html tags
const paragraphStyles = {
  p: {
    marginTop: 2,
    color: '#25182E',
    fontFamily: 'satoshi-medium',
    fontWeight: '600',
  },
};

const defaultTextSuccess = {
  ...defaultTextError,
  color: '#5cb85c',
};

/// from global styles
const formControl = {
  width: '100%',
  height: 40,
  paddingHorizontal: 16,
  backgroundColor: '#FFFFFF',
  borderRadius: 8,
  borderWidth: 1,
  borderColor: '#E5E5E5',
  alignItems: 'center',
  paddingVertical: 10,
};

const formControlNew = {
  width: '100%',
  height: 40,
  paddingHorizontal: 16,
  backgroundColor: '#FFFFFF',
  borderBottomWidth: 1,
  borderBottomColor: '#E5E5E5',
  alignItems: 'center',
  paddingVertical: 10,
  paddingTop: 10,
};

const formControlFilled = {
  backgroundColor: '#ffffff',
  borderColor: '#e5e5e5',
};

const formControlFilledNew = {
  backgroundColor: '#ffffff',
  borderBottomColor: '#e5e5e5',
};

const formControlFilledOtp = {
  backgroundColor: '#FBFAFF',
  borderColor: '#A774C8',
};

const formControlFilledNewOtp = {
  backgroundColor: '#ffffff',
  borderBottomColor: '#A774C8',
};

const formControlError = {
  ...formControl,
  backgroundColor: '#FFF8FA',
  borderColor: '#DA2A52',
};

const formAddOn = {
  backgroundColor: '#f8f8f8',
  height: 40,
  width: 68,
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: 12,
  borderRadius: 8,
  flexDirection: 'row',
};

const formAddOnText = {
  fontSize: 13,
  lineHeight: 14,
  fontFamily: 'satoshi-medium',
  color: '#25182E',
};

const formInputTextError = {
  ...defaultTextError,
  marginTop: 9,
};

const formInputText = {
  fontSize: 14,
  color: '#404040',
  fontFamily: 'satoshi-medium',
  lineHeight: 14,
};

const formControlContainer = {
  paddingHorizontal: 0,
};

const formGroup = {
  position: 'relative',
  width: '100%',
  paddingHorizontal: 6,
};

const formGroupHalf = {
  width: '50%',
};

const formGroupForgetPassword = {
  justifyContent: 'flex-end',
  marginBottom: 24,
};

const formGroupAddonPhone = {
  width: 68,
};

const formLabel = {
  marginBottom: 8,
  fontSize: 12,
  lineHeight: 21,
  fontFamily: 'satoshi-medium',
  color: '#25182E',
  fontWeight: 'normal',
};

const formLabelOutside = {
  ...formLabel,
  width: '100%',
  paddingHorizontal: 6,
};

const formLabelError = {
  ...defaultTextError,
  marginBottom: 8,
  lineHeight: 21,
};

const formWrapper = {
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'row',
  marginHorizontal: -6,
  marginBottom: 24,
};

const formRequired = {
  color: '#da2a52',
};

const formContainer = {
  padding: 15,
  width: '100%',
  height: '100%',
  backgroundColor: '#fff',
};

export {
  formAddOn,
  formAddOnText,
  formControl,
  formControlContainer,
  formControlError,
  formControlFilled,
  formControlFilledOtp,
  formInputText,
  formLabel,
  formLabelError,
  formLabelOutside,
  formGroup,
  formGroupAddonPhone,
  formWrapper,
  formGroupHalf,
  formRequired,
  formInputTextError,
  formGroupForgetPassword,
  defaultTextError,
  formContainer,
  defaultTextSuccess,
  paragraphStyles,
  formControlFilledNew,
  formControlFilledNewOtp,
  formControlNew,
};
